document.addEventListener('DOMContentLoaded', function() {
    var tabsExist = document.getElementsByClassName('section-tabs');

    if (tabsExist.length > 0) {
        const selectors = document.querySelectorAll('.section-tabs');

        selectors.forEach(function(selector) {
            var tabId = selector.getAttribute('data-tab-id');

            if (tabId !== null && selector) {
                const tabItems = selector.querySelectorAll('.tabs button');
                const tabContent = selector.querySelectorAll('.tab_content > div');

                function resetClasses() {
                    tabItems.forEach((item) => {
                        item.classList.remove('active');
                    });
                    tabContent.forEach((content) => {
                        content.classList.remove('active');
                    });
                }

                tabItems[0].classList.add('active');
                tabContent[0].classList.add('active');

                tabItems.forEach((item, index) => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault();
                        
                        resetClasses();
                        
                        item.classList.add('active');
                        tabContent[index].classList.add('active');

                    });
                });
            }
        });
    }
});